import React, { useEffect, useState } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function Offer() {
  const ref = useScrollAnimation();
  const {
    trackAddToCart
  } = useMetaPixel();
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 44,
    seconds: 45
  });
  const [selectedPack, setSelectedPack] = useState<'primaria' | 'completo' | 'secundaria'>('completo');
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const handlePrimaria = () => {
    trackAddToCart(16990, 'ARS');
    window.location.href = 'https://www.profepack.com/cart/48107968889088:1';
  };
  const handleSecundaria = () => {
    trackAddToCart(18990, 'ARS');
    window.location.href = 'https://www.profepack.com/cart/48075711054080:1';
  };
  const handleCompleto = () => {
    trackAddToCart(27990, 'ARS');
    window.location.href = 'https://www.profepack.com/cart/48074213228800:1';
  };
  return <section className="w-full bg-[#0d0d0d] py-24 px-4 border-t border-[#1a1a1a] relative pt-[0px]" ref={ref} data-id="element-62">
      {/* Subtle glow behind pricing */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[400px] bg-[#F5C518]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-63" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-64">
        {/* === URGENCY COUNTDOWN SECTION === */}
        <div className="scroll-hidden text-center py-16 px-4 bg-[#1a0a0a] rounded-2xl border border-red-900/30 max-w-3xl mx-auto mb-[100px]" data-id="element-65">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-10 leading-tight" data-id="element-66">
            ⏰ EL PRECIO DE
            <br data-id="element-67" />
            LANZAMIENTO TERMINA EN:
          </h2>

          {/* Big Red Countdown */}
          <div className="flex justify-center items-end gap-2 md:gap-6 mb-4" data-id="element-68">
            <div className="text-center" data-id="element-69">
              <div className="text-6xl md:text-8xl font-black text-red-600" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-70">
                {String(timeLeft.hours).padStart(2, '0')}
              </div>
              <div className="text-sm md:text-base text-gray-400 font-bold uppercase tracking-widest mt-1" data-id="element-71">
                HS
              </div>
            </div>
            <div className="text-6xl md:text-8xl font-black text-red-600 mb-6" style={{
            fontFamily: 'Georgia, serif'
          }} data-id="element-72">
              :
            </div>
            <div className="text-center" data-id="element-73">
              <div className="text-6xl md:text-8xl font-black text-red-600" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-74">
                {String(timeLeft.minutes).padStart(2, '0')}
              </div>
              <div className="text-sm md:text-base text-gray-400 font-bold uppercase tracking-widest mt-1" data-id="element-75">
                MIN
              </div>
            </div>
            <div className="text-6xl md:text-8xl font-black text-red-600 mb-6" style={{
            fontFamily: 'Georgia, serif'
          }} data-id="element-76">
              :
            </div>
            <div className="text-center" data-id="element-77">
              <div className="text-6xl md:text-8xl font-black text-red-600" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-78">
                {String(timeLeft.seconds).padStart(2, '0')}
              </div>
              <div className="text-sm md:text-base text-gray-400 font-bold uppercase tracking-widest mt-1" data-id="element-79">
                SEG
              </div>
            </div>
          </div>

          {/* Urgency text */}
          <p className="text-xl md:text-2xl text-white font-bold mt-8 mb-10" data-id="element-80">
            Después sube{' '}
            <span className="text-red-500 font-black" data-id="element-81">$10.000 ARS</span> y no
            vuelve a bajar.
          </p>

          {/* Cupos progress bar */}
          <div className="max-w-md mx-auto" data-id="element-82">
            <div className="flex justify-between items-center mb-2" data-id="element-83">
              <span className="text-red-400 font-bold text-sm flex items-center gap-2" data-id="element-84">
                🔴 Cupos al precio de lanzamiento
              </span>
              <span className="text-white font-bold text-sm" data-id="element-85">Quedan pocos</span>
            </div>
            <div className="w-full h-4 bg-[#2a2a3a] rounded-full overflow-hidden" data-id="element-86">
              <div className="h-full rounded-full" style={{
              width: '68%',
              background: 'linear-gradient(90deg, #ef4444, #f97316)'
            }} data-id="element-87" />
            </div>
            <p className="text-gray-400 text-sm mt-2 text-right font-medium" data-id="element-88">
              68% de los cupos tomados
            </p>
          </div>
        </div>

        {/* === PRICING SECTION === */}
        <div className="scroll-hidden text-center mb-2 md:mb-4" id="comprar" data-id="element-89">
          <h2 className="text-3xl md:text-5xl font-black text-white mt-[0px] mb-[0px]" style={{
          fontFamily: 'Georgia, serif'
        }} data-id="element-90">
            Elegí tu <span className="text-[#F5C518]" data-id="element-91">PROFEPACK:</span>
          </h2>
          <p className="text-gray-400 text-sm md:text-lg font-medium mt-[6px] mb-[6px] md:mt-[10px] md:mb-[10px]" data-id="element-92">
            Todas las opciones incluyen los 6 bonos estratégicos
          </p>
        </div>

        <div className="max-w-2xl mx-auto scroll-hidden mb-12" data-id="element-93">
          <div className="flex flex-col gap-2" data-id="element-94">
            {/* Card 1: Primaria */}
            <div onClick={() => setSelectedPack('primaria')} className={`cursor-pointer rounded-xl p-4 transition-all duration-300 ${selectedPack === 'primaria' ? 'bg-[#1a1a1a] border-2 border-[#F5C518] shadow-[0_0_20px_rgba(245,197,24,0.1)]' : 'bg-[#141414] border border-[#2a2a2a] hover:border-gray-600'}`} data-id="element-95">
              <div className="flex items-center gap-3" data-id="element-96">
                <div className="flex-shrink-0" data-id="element-97">
                  <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selectedPack === 'primaria' ? 'border-[#F5C518]' : 'border-gray-500'}`} data-id="element-98">
                    {selectedPack === 'primaria' && <div className="w-3 h-3 rounded-full bg-[#F5C518]" data-id="element-99" />}
                  </div>
                </div>
                <div className="flex-1 min-w-0" data-id="element-100">
                  <h3 className="text-white font-black text-base md:text-lg flex items-center gap-1.5" data-id="element-101">
                    <span data-id="element-102">🎨</span> ARTÍSTICA PRIMARIA
                  </h3>
                  <p className="text-gray-400 text-xs md:text-sm mt-0.5" data-id="element-103">
                    6 tomos + 120 clases + bonos
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-104">
                  <div className="text-gray-500 text-xs line-through" data-id="element-105">
                    $53.000
                  </div>
                  <div className="text-white font-black text-2xl md:text-3xl" style={{
                  fontFamily: 'Georgia, serif'
                }} data-id="element-106">
                    $16.990
                  </div>
                </div>
              </div>
            </div>

            {/* Card 2: Completo */}
            <div onClick={() => setSelectedPack('completo')} className={`cursor-pointer rounded-xl p-4 transition-all duration-300 relative ${selectedPack === 'completo' ? 'bg-[#1a1a1a] border-2 border-[#F5C518] shadow-[0_0_25px_rgba(245,197,24,0.15)]' : 'bg-[#141414] border border-[#2a2a2a] hover:border-gray-600'}`} data-id="element-107">
              <h3 className="text-white font-black text-base md:text-lg flex items-center gap-1.5 mb-2" data-id="element-108">
                <span data-id="element-109">🏆</span> PACK COMPLETO
              </h3>
              <div className="flex items-center gap-3" data-id="element-110">
                <div className="flex-shrink-0" data-id="element-111">
                  <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selectedPack === 'completo' ? 'border-[#F5C518]' : 'border-gray-500'}`} data-id="element-112">
                    {selectedPack === 'completo' && <div className="w-3 h-3 rounded-full bg-[#F5C518]" data-id="element-113" />}
                  </div>
                </div>
                <div className="flex-1 min-w-0" data-id="element-114">
                  <div className="flex flex-wrap items-center gap-1.5 mb-1.5" data-id="element-115">
                    <span className="bg-[#F5C518] text-black text-[9px] md:text-xs font-black px-2 py-0.5 rounded-full uppercase tracking-wider" data-id="element-116">
                      ⭐ MÁS ELEGIDO
                    </span>
                    <span className="bg-[#F5C518]/20 text-[#F5C518] text-[9px] md:text-xs font-bold px-2 py-0.5 rounded-full uppercase" data-id="element-117">
                      AHORRÁS $7.990
                    </span>
                  </div>
                  <p className="text-gray-400 text-xs md:text-sm" data-id="element-118">
                    12 tomos + 240 clases + bonos
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-119">
                  <div className="text-gray-500 text-xs line-through" data-id="element-120">
                    $35.980
                  </div>
                  <div className="text-[#F5C518] font-black text-2xl md:text-3xl" style={{
                  fontFamily: 'Georgia, serif'
                }} data-id="element-121">
                    $27.990
                  </div>
                </div>
              </div>
            </div>

            {/* Card 3: Secundaria */}
            <div onClick={() => setSelectedPack('secundaria')} className={`cursor-pointer rounded-xl p-4 transition-all duration-300 ${selectedPack === 'secundaria' ? 'bg-[#1a1a1a] border-2 border-[#F5C518] shadow-[0_0_20px_rgba(245,197,24,0.1)]' : 'bg-[#141414] border border-[#2a2a2a] hover:border-gray-600'}`} data-id="element-122">
              <div className="flex items-center gap-3" data-id="element-123">
                <div className="flex-shrink-0" data-id="element-124">
                  <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selectedPack === 'secundaria' ? 'border-[#F5C518]' : 'border-gray-500'}`} data-id="element-125">
                    {selectedPack === 'secundaria' && <div className="w-3 h-3 rounded-full bg-[#F5C518]" data-id="element-126" />}
                  </div>
                </div>
                <div className="flex-1 min-w-0" data-id="element-127">
                  <h3 className="text-white font-black text-base md:text-lg flex items-center gap-1.5" data-id="element-128">
                    <span data-id="element-129">🎓</span> ARTÍSTICA SECUNDARIA
                  </h3>
                  <p className="text-gray-400 text-xs md:text-sm mt-0.5" data-id="element-130">
                    6 tomos + 120 clases + bonos
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-131">
                  <div className="text-gray-500 text-xs line-through" data-id="element-132">
                    $53.000
                  </div>
                  <div className="text-white font-black text-2xl md:text-3xl" style={{
                  fontFamily: 'Georgia, serif'
                }} data-id="element-133">
                    $18.990
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="mt-3 md:mt-4 text-center" data-id="element-134">
            <button onClick={() => {
            if (selectedPack === 'primaria') handlePrimaria();else if (selectedPack === 'secundaria') handleSecundaria();else handleCompleto();
          }} className="w-full bg-[#FFD900] text-black hover:bg-[#fcd34d] hover:scale-105 px-4 py-4 md:py-5 rounded-xl font-black text-[15px] md:text-lg whitespace-nowrap transition-all duration-300 shadow-[0_4px_20px_rgba(245,197,24,0.35)]" data-id="element-135">
              {selectedPack === 'completo' && 'SÍ, QUIERO PACK COMPLETO →'}
              {selectedPack === 'primaria' && 'SÍ, QUIERO ARTE PRIMARIA →'}
              {selectedPack === 'secundaria' && 'SÍ, QUIERO ARTE SECUNDARIA →'}
            </button>
            <p className="text-gray-500 text-xs italic mt-1.5 md:mt-2" data-id="element-136">
              La opción más elegida por docentes que enseñan Arte
            </p>
          </div>
        </div>

        {/* Trust Section */}
        <div className="scroll-hidden max-w-4xl mx-auto" data-id="element-137">
          <h4 className="text-center text-gray-400 font-bold mb-8 uppercase tracking-widest text-sm" data-id="element-138">
            Comprá tranquilo/a
          </h4>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-139">
            <div className="bg-[#141414] border border-[#2a2a2a] rounded-xl p-4 text-center" data-id="element-140">
              <div className="text-2xl mb-2" data-id="element-141">🔒</div>
              <div className="text-white font-bold text-sm" data-id="element-142">Pago Seguro</div>
              <div className="text-gray-500 text-xs mt-1" data-id="element-143">Mercado Pago</div>
            </div>
            <div className="bg-[#141414] border border-[#2a2a2a] rounded-xl p-4 text-center" data-id="element-144">
              <div className="text-2xl mb-2" data-id="element-145">📩</div>
              <div className="text-white font-bold text-sm" data-id="element-146">
                Acceso Inmediato
              </div>
              <div className="text-gray-500 text-xs mt-1" data-id="element-147">
                Envío al instante
              </div>
            </div>
            <div className="bg-[#141414] border border-[#2a2a2a] rounded-xl p-4 text-center" data-id="element-148">
              <div className="text-2xl mb-2" data-id="element-149">🛡️</div>
              <div className="text-white font-bold text-sm" data-id="element-150">
                Garantía 7 Días
              </div>
              <div className="text-gray-500 text-xs mt-1" data-id="element-151">Riesgo cero</div>
            </div>
            <div className="bg-[#141414] border border-[#2a2a2a] rounded-xl p-4 text-center" data-id="element-152">
              <div className="text-2xl mb-2" data-id="element-153">🔄</div>
              <div className="text-white font-bold text-sm" data-id="element-154">
                Actualizaciones
              </div>
              <div className="text-gray-500 text-xs mt-1" data-id="element-155">
                Gratis de por vida
              </div>
            </div>
          </div>
        </div>

        {/* Guarantee Badge */}
        <div className="scroll-hidden mt-8 max-w-3xl mx-auto bg-[#141414] border border-[#2a2a2a] rounded-xl p-6 flex flex-col sm:flex-row items-center justify-center gap-4 text-center sm:text-left" data-id="element-156">
          <span className="text-4xl" data-id="element-157">🛡️</span>
          <div data-id="element-158">
            <h4 className="text-white font-bold text-lg" data-id="element-159">
              Garantía de satisfacción 7 días
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-160">
              Si no te sirve, te devolvemos el 100% de tu dinero sin preguntas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}